<div>
    <div class="actions">
      <button (click)="backPage()" class="btn-action">
        <fa-icon [icon]="['fas', 'arrow-circle-left']" class="fa-thin"></fa-icon>
         Back
      </button>
      <button *ngIf="isSuperUser" (click)="addCamera()" class="btn-action">
        <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
         Add Camera
      </button>
    </div>
   
    <div class="container-table">
      <div class="top-header">
        <h3>Cameras</h3>
        <p>Camera management for {{ orgName }}</p>
      </div>
      <div>
          <app-shared-table-toolbar>
              <div toolbarSearch class="search-bar">
              <app-generic-search
                [apiUrl]="'cameras/search_suggestion'"
                [resultsApiUrl]="'cameras/'"
                [method]="'GET'"
                [searchParamName]="'q'"
                [pageSize]="10"
                [minChars]="2"
                (resultsFetched)="onResults($event)">
              </app-generic-search>
              </div>
              <button toolbarTrailing type="button" (click)="exportToExcel()" class="export-button">
            <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
            EXPORT EXCEL
          </button>
          </app-shared-table-toolbar>
        <div class="responsive-table-wrapper">
          <table>
            <thead>
                <tr>
                <th>S.No</th>
                <th>Camera Name</th>
                <th>Camera ESN</th>
                <th>Organization</th>
                <th>Direction</th>
                <th>Created At</th>
                <th>Status</th>
                <th>Action Items</th>
                </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let record of cameraData; let i = index">
                <tr [class.camera-row-expanded]="isCameraRowExpanded(record)">
                    <td>
                        <div class="camera-sno-cell">
                            <button
                                    type="button"
                                    class="camera-expand-toggle"
                                    (click)="toggleCameraRowExpand(record, $event)"
                                    [attr.aria-expanded]="isCameraRowExpanded(record)"
                                    [attr.aria-label]="cameraExpandControlLabel(isCameraRowExpanded(record))">
                        <span class="camera-expand-caret"
                              [class.camera-expand-caret-open]="isCameraRowExpanded(record)"
                              aria-hidden="true">&#9662;</span>
                            </button>
                            <span>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</span>
                        </div>
                    </td>
                  <td>
                    <div class="text-clip" (click)="openReason(record.description)">
                      {{ cameraNameDisplay(record.description) }}
                    </div>
                  </td>
                  <td class="table-actions-cell">
                    <span class="camera-esn-badge">{{ record.camera_esn }}</span>
                      <app-copy-button [value]="record.camera_esn" copyTitle="Copy Camera ESN"></app-copy-button>
                  </td>
                  <td>{{ record.organization}}</td>
                  <td>
                    <app-camera-direction-indicator [direction]="record.direction"></app-camera-direction-indicator>
                  </td>
                  <td>{{ record.created_at | reportingDate }}</td>
                  <td>
                    <span class="status-pill" [class.active]="record.is_active" [class.inactive]="!record.is_active">
                      {{ record.is_active ? 'Enabled' : 'Disabled' }}
                    </span>
                  </td>
                  <td class="table-actions-cell">
                  <label *ngIf="isSuperUser" class="toggle-switch" [title]="record.is_active ? 'Disable' : 'Enable'">
                    <input type="checkbox" [checked]="record.is_active" (change)="toggleCameraStatus(record, $event)" [disabled]="record._toggling" />
                    <span class="toggle-slider"></span>
                  </label>
                      <button *ngIf="isSuperUser" class="action-button bt-edit" (click)="updateCamera(record.id)"
                              title="Edit">
                    <span>
                      <fa-icon [icon]="['fas', 'pen']" class="fa-light"></fa-icon>
                    </span>
                  </button>
                      <button *ngIf="isSuperUser" class="action-button bt-delete"
                              (click)="openConfirmationDialog(record.id)" title="Delete">
                    <span>
                      <fa-icon [icon]="['fas', 'trash']" class="fa-light"></fa-icon>
                    </span>
                  </button>
                      <span *ngIf="!isSuperUser" class="text-muted" title="Read-only">View only</span>
                </td>
                </tr>
                <tr *ngIf="isCameraRowExpanded(record)" class="camera-detail-row">
                    <td colspan="8">
                        <div class="camera-detail-card">
                            <div>
                                <h4 class="camera-detail-heading">Camera</h4>
                                <dl class="camera-detail-grid">
                                    <div class="camera-detail-item">
                                        <dt>ESN</dt>
                                        <dd>{{ cameraOptionalValue(record.camera_esn) }}</dd>
                                    </div>
                                    <div class="camera-detail-item">
                                        <dt>Direction</dt>
                                        <dd>
                                            <app-camera-direction-indicator
                                                    [direction]="record.direction"></app-camera-direction-indicator>
                                        </dd>
                                    </div>
                                    <div class="camera-detail-item">
                                        <dt>Enabled</dt>
                                        <dd>{{ record.is_active ? 'Enabled' : 'Disabled' }}</dd>
                                    </div>
                                </dl>
                            </div>
                            <div>
                                <h4 class="camera-detail-heading">Analytics</h4>
                                <dl class="camera-detail-grid">
                                    <div class="camera-detail-item">
                                        <dt>Analytics configured</dt>
                                        <dd>{{ record.status.analytics_configured ? 'Configured' : 'None' }}</dd>
                                    </div>
                                    <div class="camera-detail-item">
                                        <dt>Enabled analytics</dt>
                                        <dd>{{ cameraEnabledAnalyticsLabel(record) }}</dd>
                                    </div>
                                    <div class="camera-detail-item">
                                        <dt>Enabled count</dt>
                                        <dd>{{ cameraOptionalValue(record.status.enabled_analytics_count) }}</dd>
                                    </div>
                                    <div class="camera-detail-item">
                                        <dt>Vehicle Detection</dt>
                                        <dd>{{ record.status.vehicle_detection_enabled ? 'Enabled' : 'Disabled' }}</dd>
                                    </div>
                                    <div class="camera-detail-item">
                                        <dt>Correlation window</dt>
                                        <dd>{{ cameraCorrelationWindowLabel(record.status.correlation_window_seconds)
                                            }}
                                        </dd>
                                    </div>
                                </dl>
                            </div>
                            <div>
                                <h4 class="camera-detail-heading">Device Health</h4>
                                <p *ngIf="cameraDeviceHealthMissing(record)" class="camera-detail-unavailable">Not
                                    available</p>
                                <dl *ngIf="!cameraDeviceHealthMissing(record)" class="camera-detail-grid">
                                    <div class="camera-detail-item">
                                        <dt>Primary status</dt>
                                        <dd>{{ cameraOptionalValue(record.status.device_health?.primary_status) }}</dd>
                                    </div>
                                    <div class="camera-detail-item">
                                        <dt>Connection status</dt>
                                        <dd>{{ cameraOptionalValue(record.status.device_health?.connection_status) }}
                                        </dd>
                                    </div>
                                    <div class="camera-detail-item">
                                        <dt>Mapping status</dt>
                                        <dd>{{ cameraOptionalValue(record.status.device_health?.mapping_status) }}</dd>
                                    </div>
                                </dl>
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-container>
            </tbody>
          </table>
          <div class="footer">
            <div class="total-records">Total Records: {{ totalRecords }}</div>
              <app-vte-pagination
                      [currentPage]="currentPage"
                      [pageSize]="recordsPerPage"
                      [totalRecords]="totalRecords"
                      [showJumpToPage]="true"
                      (pageChange)="onPageChange($event)"
                      (pageSizeChange)="onPageSizeChange($event)">
              </app-vte-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showConfirmationDialog" class="confirmation-modal">
    <div class="modal-content">
      <div class="modal-header">
        <!-- <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10" stroke="#6A5ACD" stroke-width="2" fill="none"/>
        <path d="M9 12l2 2 4-4" stroke="#FFFFFF" stroke-width="2"/>
        </svg> -->
         <i class="bi bi-exclamation-triangle warning-icon"></i>
        <h3>Are You Sure?</h3>
      </div>
      <div class="modal-body">
        <p>Do you want to permanently Delete this Camera ? Confirm your choice below!</p>
      </div>
      <div class="modal-footer">
        <button (click)="confirmDelete()" class="confirm-btn modal-red">Yes, Proceed</button>
        <button (click)="closeConfirmationDialog()" class="cancel-btn cancel-btn-green">Cancel</button>
      </div>
  </div>
  </div>

  <!-- Modal for showing reason -->
  <div *ngIf="showReason" class="confirmation-modal">
    <div class="modal-content">
      <div class="close">
        <span  (click)="closeReason()">
          <fa-icon [icon]="['fas', 'circle-xmark']" class="fa-thin"></fa-icon>
        </span>
      </div>
      <div class="mod-text">
        <p>{{reason}}</p>
      </div>
    </div>
  </div>
